<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">INPC</h3>
				<div class="card-tools">
					<button @click="newForm()" v-can="'add_inpc'" class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Registro
					</button>
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<label>Buscar :</label>
						<input type="text" class="form-control" v-model="search.name" @keyup="list()" />
					</div>
				</div>
				<br>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Nombre</th>
								<th>Fecha</th>
								<th>Valor</th>
								<th>Usuario</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="7">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="inpc.data && inpc.data.length > 0">
							<tr v-for="(account, index) in inpc.data" :key="index">
								<td>{{ account.id }}</td>
								<td>{{ account.name }}</td>
								<td>{{ account.date | toDateTime }}</td>
								<td>{{ account.value  }}</td>
								<td>{{ account.user.name }} {{ account.user.last_name }}</td>
								<td>
									<a :href="`${globalUrlFiles}${account.file}`"
										v-if="account.file != '' && account.file != null" target="_blank"
										class="btn btn-sm btn-outline-info"> <i class="fa-regular fa-file-pdf"></i>
										Caratula
									</a>
									<button @click="newForm(account)" :to="`/inpc/form/${account.id}`"
										v-can="'edit_inpc'" class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</button>

									<button type="button" @click="deleted(account.id)" v-can="'delete_inpc'"
										class="btn-outline-danger btn m-1 btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="5">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
					<pagination v-model="page" :records="inpc.total" :per-page="inpc.per_page" @paginate="list" />
				</div>
			</div>
		</div>
		<ModalFormComponent />
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import request from '@/services/request'
import ModalFormComponent from '@/components/inpc/ModalFormComponent.vue';
import Pagination from 'vue-pagination-2';
export default {
	components: {
		ModalFormComponent,
		Pagination
	},
	name: "inpc-table",
	// components: {
	// 	pagination,
	// },
	data() {
		return {
			inpc: [],
			search: {
				name: ''
			},
			load: false,
			page: 1
		}
	},
	mounted() {
		this.list();
	},
	created() {
		Event.$on("event-load-inpc", () => {
			this.list();
		});
	},
	methods: {
		newForm(account = {}) {
			Event.$emit('event-show-addINPC', account);
		},
		deleted: function (id) {
			let tit = 'Eliminar INPC';
			let txt = 'Seguro que quiere eliminar al INPC';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.load = true;
					let _endpoint = '/inpc/' + id;
					try {
						let response = await request.destroy(_endpoint).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
						this.load = false;
					} catch (error) {
						this.errors = await this.errorNotification(error)
						this.load = false;
					}
				}
			});
		},
		showImport() {
			this.$modal.show('example');
		},
		async list(page = 1) {
			this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/inpc';
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					console.log(data);
					this.inpc = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	}
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}
</style>
